import React from 'react';
import { useSelector } from 'react-redux';
import { Layout, MenuItemLink, UserMenu, AppBar,
    useTranslate, usePermissions } from 'react-admin';
import MeIcon from '@material-ui/icons/Edit';

import schools from './containers/schools';
import supervisors from './containers/supervisors';
import players from './containers/players';
import lesson_groups from './containers/lesson_groups';
import { Separator } from './containers/ui_components';
import { getName } from './authProvider';

const MyUserMenu = (props) => {
  const translate = useTranslate();
  return (
    <UserMenu {...props} label={`${translate('ra.auth.username')}:${getName()}`} >
      <MenuItemLink
        to="/me"
        primaryText={translate('ra.action.edit')}
        leftIcon={<MeIcon />}
      />
    </UserMenu>
  );
}

const MyAppBar = props => {
  return (
    <AppBar {...props} userMenu={<MyUserMenu />} />
  );
};

const Menu = ({ onMenuClick, dense, logout }) => {
  const { loaded, permissions } = usePermissions();
  const translate = useTranslate();
  const open = useSelector((state) => state.admin.ui.sidebarOpen);
  const owner = loaded && permissions && permissions.isOwner;

  return (
    <div>
      {' '}
      {(owner && <MenuItemLink
        to={`/schools/0`}
        primaryText={translate('resources.schools.name')}
        leftIcon={<schools.icon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />)}
      <MenuItemLink
        to={`/supervisors`}
        primaryText={translate('resources.supervisors.name')}
        leftIcon={<supervisors.icon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      <MenuItemLink
        to={`/players`}
        primaryText={translate('resources.players.name')}
        leftIcon={<players.icon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />
      {(owner && <MenuItemLink
        to={`/lesson_groups`}
        primaryText={translate('resources.lesson_groups.name')}
        leftIcon={<lesson_groups.icon />}
        onClick={onMenuClick}
        sidebarIsOpen={open}
        dense={dense}
      />)}
      <Separator pt='5em' />
      {logout}
    </div>
  );
};

const emptyMenu = () => (
  <div style={{ width: 0 }} />
);

export default (props) => {
  const { loading, permissions } = usePermissions();
  const hideMenu = loading || !permissions || permissions.isFirstLogin;
  const menu = hideMenu ? emptyMenu: Menu;
  const defaultTheme = {
    palette: {
      secondary: {
        main: '#0C487A',
      },
    },
    sidebar: {
      width: '16em',
    }
  };
  const theme = hideMenu
    ? {
      ...defaultTheme,
      sidebar: {
        width: 20,
        closedWidth: 20
      }
    }
    : defaultTheme;
  return (
    <Layout {...props}
      menu={menu}
      theme={theme}
      appBar={MyAppBar}
    />
  );
};
